/* U7 home page — flavor & strength picker controllers. Progressive enhancement. */
(function () {
  if (window.__u7PickersInit) return;
  window.__u7PickersInit = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var hasIO = 'IntersectionObserver' in window;

  function safePlay(v) {
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  }

  function initPickers() {
    document.querySelectorAll('[data-u7-picker]').forEach(function (root) {
      var pills = Array.prototype.slice.call(root.querySelectorAll('[data-u7-pill]'));
      var cans = Array.prototype.slice.call(root.querySelectorAll('[data-u7-can]'));
      var canBtns = Array.prototype.slice.call(root.querySelectorAll('[data-u7-can-btn]'));
      var fx = Array.prototype.slice.call(root.querySelectorAll('[data-u7-can-fx]'));
      var current = 0;
      // QA-0808: fx playback is gated on the section being (near) on screen, so the
      // 5MB alpha renders neither download nor decode while the visitor is elsewhere.
      var inView = !hasIO;
      // US-008: play only the active flavor's bubble video; pause the rest (1 at a time).
      // QA-0701: the static can stays visible until the video actually renders frames
      // (`is-fx-live` on the button), so the first click can't flash an empty slot.
      function playFx(index) {
        current = index;
        if (reduced) { return; }
        fx.forEach(function (v) {
          var btn = v.closest('[data-u7-can-btn]');
          if (parseInt(v.getAttribute('data-u7-fx-index'), 10) === index && inView) {
            if (!v.__u7LiveBound) {
              v.__u7LiveBound = true;
              v.addEventListener('playing', function () {
                var b = v.closest('[data-u7-can-btn]');
                if (b) { b.classList.add('is-fx-live'); }
              });
            }
            safePlay(v);
          } else {
            v.pause();
            if (btn) { btn.classList.remove('is-fx-live'); }
          }
        });
      }
      function activate(index) {
        pills.forEach(function (p, i) { p.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
        cans.forEach(function (can, i) { can.classList.toggle('is-active', i === index); });
        canBtns.forEach(function (b, i) { b.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
        var pill = pills[index];
        var link = root.querySelector('[data-u7-picker-link]');
        var href = pill && pill.getAttribute('data-u7-link');
        if (link && href) { link.setAttribute('href', href); }
        playFx(index);
      }
      pills.forEach(function (pill, index) {
        pill.addEventListener('click', function () { activate(index); });
      });
      // US-008: clicking a can image selects that flavor too.
      // Client 0810: tapping the already-active can goes straight to that
      // flavor's PDP (same variant deep-link SHOP NOW carries) — saves the
      // select-then-SHOP-NOW double step. Pills keep select-only behavior.
      canBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-u7-can-index'), 10);
          if (isNaN(idx)) { return; }
          if (idx === current) {
            var pill = pills[idx];
            var href = pill && pill.getAttribute('data-u7-link');
            if (!href) {
              var link = root.querySelector('[data-u7-picker-link]');
              href = link && link.getAttribute('href');
            }
            if (href) { window.location.href = href; return; }
          }
          activate(idx);
        });
      });
      if (hasIO && fx.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
            playFx(current);
          });
        }, { rootMargin: '25% 0px' });
        io.observe(root);
      }
      // Activate the first flavor on load so its bubble animation plays (cans-only,
      // so the tablets strength picker — no cans — keeps its original load state).
      if (cans.length && pills.length) { activate(0); }
    });
  }

  // QA-0808: viewport-gated playback for standalone autoplay loops (hero, pour
  // render). Entering the viewport (re)tries play; leaving pauses to free the
  // decoder. A one-time interaction kick recovers loops that Chrome refused to
  // autoplay (battery saver / autoplay policy).
  function initIoVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-u7-io-video]'));
    if (!vids.length || reduced) { return; }
    if (!hasIO) { vids.forEach(safePlay); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { if (entry.target.paused) { safePlay(entry.target); } }
        else { entry.target.pause(); }
      });
    }, { rootMargin: '25% 0px' });
    vids.forEach(function (v) { io.observe(v); });
    var kick = function () {
      window.removeEventListener('pointerdown', kick);
      window.removeEventListener('touchstart', kick);
      window.removeEventListener('keydown', kick);
      vids.forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (v.paused && r.bottom > 0 && r.top < window.innerHeight) { safePlay(v); }
      });
    };
    window.addEventListener('pointerdown', kick, { passive: true });
    window.addEventListener('touchstart', kick, { passive: true });
    window.addEventListener('keydown', kick);
  }

  // QA-0808 (replaces QA-0701 prefetch): warm the flavor animations so a click
  // swaps to a ready video — but strictly ONE at a time. The old prefetch set
  // preload=auto on all nine ~5MB renders at once, which on cold (incognito)
  // loads saturated the connection and stalled both the hero video and the
  // active can animation.
  function warmFx() {
    if (reduced || saveData) { return; }
    var queue = Array.prototype.slice.call(document.querySelectorAll('[data-u7-can-fx]'));
    function next() {
      var v = queue.shift();
      if (!v) { return; }
      // Skip anything already buffered, already warming, or currently playing
      // (calling load() on a playing element would reset it).
      if (!v.paused || v.readyState >= 3 || v.preload === 'auto') { return next(); }
      var done = false;
      var timer = setTimeout(finish, 6000);
      function finish() {
        if (done) { return; }
        done = true;
        clearTimeout(timer);
        v.removeEventListener('canplaythrough', finish);
        v.removeEventListener('error', finish);
        next();
      }
      v.addEventListener('canplaythrough', finish);
      v.addEventListener('error', finish);
      v.preload = 'auto';
      v.load();
    }
    next();
  }

  function init() { initPickers(); initIoVideos(); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  // Delay the warm-up so the hero video and the active animations get the
  // connection to themselves first.
  if (document.readyState === 'complete') { setTimeout(warmFx, 2500); }
  else { window.addEventListener('load', function () { setTimeout(warmFx, 2500); }); }
})();
